import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;

    this.section.addEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice
    );

    this.waitingForGridSelection = false;

    if (this.dataset.gridPriceRange) {
      const container = this.querySelector('[ref="priceContainer"]');

      if (container) {
        this.originalPrice = container.cloneNode(true);
        this.waitingForGridSelection = true;

        const range = document.createElement('span');
        range.className = 'price';
        range.textContent = this.dataset.gridPriceRange;
        container.replaceChildren(range);

        this.section.addEventListener('click', this.handlePackClick);
        this.section.addEventListener('change', this.handlePackChange);
      }
    }
  }

  disconnectedCallback() {
    if (!this.section) return;

    this.section.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice
    );
    this.section.removeEventListener('click', this.handlePackClick);
    this.section.removeEventListener('change', this.handlePackChange);
  }

  matchesPicker(target) {
    if (!(target instanceof Element)) return false;

    const picker = target.closest('variant-picker');
    return picker?.dataset.productId === this.dataset.productId;
  }

  restoreInitialPrice() {
    if (!this.waitingForGridSelection) return;

    const container = this.querySelector('[ref="priceContainer"]');
    if (container && this.originalPrice) {
      container.replaceWith(this.originalPrice.cloneNode(true));
    }

    this.waitingForGridSelection = false;
  }

  handlePackClick = (event) => {
    if (
      event.target instanceof HTMLInputElement &&
      event.target.type === 'radio' &&
      this.matchesPicker(event.target)
    ) {
      this.restoreInitialPrice();
    }
  };

  handlePackChange = (event) => {
    if (
      event.target instanceof HTMLSelectElement &&
      this.matchesPicker(event.target)
    ) {
      this.restoreInitialPrice();
    }
  };

  /**
   * @param {VariantUpdateEvent} event
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newProductPrice = event.detail.data.html.querySelector(
      `product-price[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newProductPrice) return;

    const newPrice = newProductPrice.querySelector(
      '[ref="priceContainer"]'
    );
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (newPrice && currentPrice) {
      currentPrice.replaceWith(newPrice);
      this.waitingForGridSelection = false;
    }

    const currentNote = this.querySelector('.volume-pricing-note');
    const newNote = newProductPrice.querySelector(
      '.volume-pricing-note'
    );

    if (!newNote) {
      currentNote?.remove();
    } else if (!currentNote) {
      this.querySelector('[ref="priceContainer"]')
        ?.insertAdjacentElement(
          'afterend',
          newNote.cloneNode(true)
        );
    } else {
      currentNote.replaceWith(newNote);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}